<template>
  <div>

    <!-- 导入弹窗 -->
    <el-dialog title="导入数据"
               :visible.sync="dialogVisible"
               width="500px"
               :close-on-click-modal="false"
               @close="handleClose">
      <el-form :model="formData"
               label-width="80px"
               size="medium">
        <!-- 老师选择 -->
        <el-form-item label="选择老师"
                      required>
          <el-select v-model="formData.teacherId"
                     placeholder="请选择老师"
                     clearable
                     filterable
                     style="width: 100%">
            <el-option v-for="teacher in teacherList"
                       :key="teacher.id"
                       :label="`${teacher.company.company_name}/${teacher.alias}/${teacher.phone}`"
                       :value="teacher.id"></el-option>
          </el-select>
        </el-form-item>

        <!-- 文件上传 -->
        <el-form-item label="上传文件"
                      required>
          <el-upload class="upload-demo"
                     drag
                     action="#"
                     :auto-upload="false"
                     :on-change="handleFileChange"
                     :file-list="fileList"
                     :limit="1"
                     :on-exceed="handleExceed"
                     accept=".xlsx, .xls, .csv">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip"
                 slot="tip">
              只能上传Excel/CSV文件，且不超过10MB
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div style="margin-bottom: 20px;">{{message}}</div>
      <el-table :data="arr_fail_info"
                border
                style="width: 100%"
                max-height="400"
                v-if="arr_fail_info.length>0">
        <el-table-column prop="row_index"
                         label="行号"
                         width="80"
                         align="center">
        </el-table-column>

        <el-table-column prop="error_message"
                         label="错误原因"
                         min-width="300"
                         show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   :loading="importing"
                   @click="handleImport">导入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { companyuserlist, preTeacherImport } from '@/request/api'
import { crmUrl } from '@/utils/helper.js'

export default {
  name: 'ImportDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isVisible: {
      handler(val) {
        this.dialogVisible = val // 单向同步
      },
      immediate: true,
    },
  },
  data() {
    return {
      // 弹窗显示状态
      dialogVisible: false,
      // 导入中状态（防止重复提交）
      importing: false,
      // 表单数据
      formData: {
        teacherId: '',
      },
      // 上传文件列表（符合el-upload数据结构）
      fileList: [],

      teacherList: [],
      message: '',
      arr_fail_info: [],
    }
  },
  mounted() {
    this.fetchTeacherList()
  },
  methods: {
    //获取老师列表
    fetchTeacherList() {
      companyuserlist({ isPaging: 0 }).then((res) => {
        this.teacherList = res.data.data.list
      })
    },
    /**
     * 文件改变时的回调（用于获取文件对象）
     * @param {File} file - 上传的文件对象
     * @param {Array} fileList - 文件列表
     */
    handleFileChange(file, fileList) {
      this.fileList = fileList.slice(-1) // 只保留最新一个文件
    },

    /**
     * 超过文件数量限制时的提示
     */
    handleExceed() {
      this.$message.warning('只能上传一个文件，请先移除当前文件')
    },

    /**
     * 关闭弹窗时的重置操作
     */
    handleClose() {
      // 重置表单
      this.formData.teacherId = ''
      // 清空文件列表
      this.fileList = []
      // 重置导入状态
      this.importing = false
      // 重置错误信息
      
      this.dialogVisible = false

      this.$emit('close')
    },

    /**
     * 导入功能核心逻辑
     */
    async handleImport() {
      // 校验老师是否选择
      if (!this.formData.teacherId) {
        this.$message.error('请选择老师')
        return
      }

      // 校验是否有上传文件
      if (this.fileList.length === 0) {
        this.$message.error('请选择要导入的文件')
        return
      }

      // 获取文件对象
      const file = this.fileList[0].raw
      console.log(file)

      // 额外校验文件大小（10MB限制）
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!')
        return
      }

      // 开启loading，防止重复点击
      this.importing = true

      const selectedTeacher = this.teacherList.find(
        (t) => t.id === this.formData.teacherId
      )
      const formData = new FormData()
      formData.append('file', file) // 文件
      formData.append('handle_cid', selectedTeacher.cid)
      formData.append('handle_uid', selectedTeacher.uid)
      let str = crmUrl()
      this.$axios({
        url: `${str}/api/v1/sharePlatform/preTeacher/byImport`,
        method: 'post',
        data: formData,
        headers: {
          Authorization: localStorage.getItem('admin_token'),
        },
      }).then((res) => {
        this.importing = false
        this.message = `共${res.data.data.count_total}条，导入成功${res.data.data.count_success}条，导入失败${res.data.data.count_fail}`
        if (res.data.data.count_success > 0) {
          this.emit('updateData')
        }
        if (res.data.data.count_fail == 0) {
          this.$message.success('导入成功！')
          setTimeout(() => {
            this.handleClose()
          }, 1000)
        }
        if (res.data.data.count_fail > 0) {
          this.arr_fail_info = res.data.data.arr_fail_info
        }
      })
    },
  },
}
</script>

<style scoped>
/* 可根据需要调整样式 */
.upload-demo {
  width: 100%;
}
</style>